module.exports = __webpack_public_path__ + "static/media/window.d6597241.obj";